import useProducts from "./useProducts";
import useCart from "./useCart";

export default function useProduct(){

    const productsQuery = useProducts();

    const products = productsQuery.isSuccess ? productsQuery.data : [];

    const { cart } = useCart();

    if(!cart.product) return null;

    return products.find(p => p.id.toString() === cart.product) || null;
}